import React, { useEffect, useState } from 'react';
import WeeklyRevenueDashboardContainer from '../components/weeklyRevenueDashboardContainer';
import CalendarComparisonTable from '../components/CalendarComparisonTable';
import FinancialYearComparisonTable from '../components/FinancialYearComparisonTable';
import RevenueFYMReportTable from '../components/RevenueFYMReportTable';


const DashboardHome = () => {
  const [activeTab, setActiveTab] = useState('financial'); // Default to Financial Year tab
 
  const currentYear = new Date().getFullYear();
  
  // Calculate FY label for the header: e.g., "2025/2026"
  const now = new Date();
  const fyStart = now.getMonth() + 1 >= 7 ? now.getFullYear() : now.getFullYear() - 1;
  const fyLabel = `${fyStart}/${fyStart + 1}`;
 
  return (
  <div className="space-y-3">
      <div className="w-full">

        {/* Tab Navigation */}
        <div className="border-b border-gray-200 mb-3">
          <nav className="-mb-px flex space-x-6" aria-label="Tabs">
            <button
              onClick={() => setActiveTab('weekly')}
              className={`
                py-3 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'weekly'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `}
            >
              5-Weeks Performance (Revenue Stream)
            </button>

            <button
              onClick={() => setActiveTab('calendar')}
              className={`
                py-3 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'calendar'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `}
            >
             This Calendar Year (Revenue Stream)
            </button>

            <button
              onClick={() => setActiveTab('financial')}
              className={`
                py-3 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'financial'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `}
            >
            This Financial Year (Revenue Stream)
            </button>
            <button
              onClick={() => setActiveTab('fym_report')}
              className={`
                py-3 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'fym_report'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `}
            >
             All Financial Year(s) (Month & Revenue Stream)
            </button>
          </nav>
          
        </div>

        {/* Tab Content */}
        <div className="mt-3">
          {activeTab === 'weekly' && (
            <div className="animate-fadeIn">
              <WeeklyRevenueDashboardContainer />
            </div>
          )}

          {activeTab === 'calendar' && (
            <div className="animate-fadeIn bg-white p-4 rounded-lg shadow-sm border">
              <div className="mb-3">
                <h2 className="text-lg font-semibold text-gray-800">
                  Sub-County Comparison: {currentYear} (Jan - Dec)
                </h2>
                <p className="text-xs text-gray-500">
                  Consolidated revenue streams by calendar month
                </p>
              </div>
              <CalendarComparisonTable year={currentYear} />
            </div>
          )}

          {activeTab === 'financial' && (
            <div className="animate-fadeIn bg-white p-4 rounded-lg shadow-sm border">
              <FinancialYearComparisonTable />
            </div>
          )}
            {activeTab === 'fym_report' && (
            <div className="animate-fadeIn bg-white p-4 rounded-lg shadow-sm border">
              <RevenueFYMReportTable />
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default DashboardHome;